import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import React from 'react';

export const styles = {
  addPath: {
    margin: '8px 0',
  },
  text: {
    paddingLeft: '8px',
  },
  button: {
    background: '#fff',
  },
};

const AddPathComponent = ({ classes, intl, disabled, addPathDispatch }) => (
  <Grid container spacing={8}>
    <Grid item xs={12} className={classes.addPath}>
      <Button
        variant="outlined"
        color="primary"
        size="medium"
        className={classes.button}
        disabled={disabled}
        onClick={() => addPathDispatch()}
      >
        <AddIcon />
        <span className={classes.text}>
          {intl.formatMessage({
            id: 'journeyBuilder.decisionSplit_decisionPath',
          })}
        </span>
      </Button>
    </Grid>
  </Grid>
);

AddPathComponent.displayName = 'AddPathComponent';

export default AddPathComponent;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/AddPathComponent.js